import styled from "styled-components";

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px;
    height: 100%;
    width: 100%;
`;

export const Information = styled.strong`
    font-size: 16px;
    margin: 0;
    text-align: left;
`;

export const InformationContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Icon = styled.span`
    display: inline-block;
    font-size: 35px;
`;
